type TAsrTranscriptWithProvenance = {
  provenance?: {
    model?: unknown;
  };
  speech_model?: unknown;
};

export const ASR_MODEL_UNKNOWN = 'UNKNOWN';

const normalizeModel = (model: unknown): string | null => {
  if (typeof model !== 'string') {
    return null;
  }

  const normalizedModel = model.trim();
  return normalizedModel || null;
};

export const getAsrModel = (asrTranscript: unknown): string => {
  if (!asrTranscript || typeof asrTranscript !== 'object') {
    return ASR_MODEL_UNKNOWN;
  }

  const transcript = asrTranscript as TAsrTranscriptWithProvenance;
  const provenance = transcript.provenance;
  if (provenance && typeof provenance === 'object') {
    return normalizeModel(provenance.model) ?? normalizeModel(transcript.speech_model) ?? ASR_MODEL_UNKNOWN;
  }

  return normalizeModel(transcript.speech_model) ?? ASR_MODEL_UNKNOWN;
};
